import { z } from 'zod';

export const createProjectSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, 'Title is required')
    .max(200, 'Title must be 200 characters or less'),
  summary: z
    .string()
    .refine(
      (value) => [...value].length <= 280,
      'Summary must be 280 characters or less'
    )
    .optional()
    .default(''),
  description: z
    .string()
    .trim()
    .min(1, 'Description is required')
    .max(5000, 'Description must be 5000 characters or less'),
  url: z
    .string()
    .refine(
      (val) => {
        if (val === '') return true;
        try {
          const url = new URL(
            /^https?:\/\//i.test(val) ? val : 'https://' + val
          );
          return (
            ['http:', 'https:'].includes(url.protocol) &&
            !url.username &&
            !url.password &&
            !/\s/.test(val) &&
            ![...val].some(
              (char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127
            ) &&
            new TextEncoder().encode(url.href).length <= 2048 &&
            url.hostname.includes('.')
          );
        } catch {
          return false;
        }
      },
      { message: 'Please enter a valid website URL' }
    )
    .optional()
    .default(''),
  projectType: z.coerce
    .number()
    .int()
    .min(0, 'Please select a project type')
    .max(5),
  budget: z.coerce.number().int().min(0, 'Please select a budget range').max(3),
  deliveryTime: z.coerce
    .number()
    .int()
    .min(0, 'Please select a delivery time')
    .max(3),
  deliveryDate: z.string().optional().default(''),
});

export type FormData = z.infer<typeof createProjectSchema>;

export const STEP1_FIELDS: (keyof FormData)[] = [
  'title',
  'summary',
  'description',
  'url',
  'projectType',
];
